/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useState, useEffect } from "react";

// react-router-dom components

// @mui material components
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import { styled } from "@mui/system";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// sweetalert2 components
import Swal from "sweetalert2";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
import DataTable from "Tables/DataTable";
import CreateOddsFilter from "Modals/CreateOddsFilterNew";
import CheckObjectDeletion from "Modals/CheckObjectDeletion";

// Soft UI Dashboard PRO React components
import SoftBadge from "components/SoftBadge";

// ProductsList page components
import ActionCell from "views/odds-settings-list/components/ActionCell";

import { getData, postData, delData, putData } from "Utils/server";
import { getAuthorizationHeader, getUserData, setUserData } from "Utils/helpers";

import { useSoftUIController, setPlatform } from "context";
import { Grid, Menu, ToggleButton, ToggleButtonGroup } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

// Badges
const disabledTemplate = (
  <SoftBadge variant="contained" color="error" size="xs" badgeContent="Disabled" container />
);
const enabledTemplate = (
  <SoftBadge variant="contained" color="success" size="xs" badgeContent="Enabled" container />
);

/**
 *
 */
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    //backgroundColor: "#f5f5f9",
    backgroundColor: "#000",
    color: "rgba(f, f, f, 1)", //"rgba(0, 0, 0, 0.87)",
    placement: "left",
    maxWidth: 500,
    minWidth: "minContent",
    height: "minContent",
    textAlign: "left",
    fontSize: "0.65erm",
    border: "1px solid #dadde9",
    boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
    padding: "15px",
  },
}));

let providersOptions = null;

/**
 *
 * @returns
 */
function OddsSettingsList() {
  const abortController = new AbortController();

  const userData = getUserData();

  let defaultStaticOddReactionJson = { value: 0, operator: "+" };
  const [controller, dispatch] = useSoftUIController();
  const { platform, providers } = controller;

  const [showCreateModal, setCreateModal] = useState(false);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState(0);
  const [recordSelectedData, setRecordSelectedData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [oddsStyles, setOddsStyles] = useState(["decimal"]);
  const [openOddsStylesMenu, setOpenOddsStylesMenu] = useState(false);
  const [changesExist, setChangesExist] = useState(false);

  const [dataTableData, setDataTableData] = useState({
    columns: [
      { Header: "id", accessor: "id", width: "100px" },
      { Header: "name", accessor: "name", width: "100px" },
      // { Header: "template", accessor: "template", width: "100px", Cell: showEnabled },
      // { Header: "provider", accessor: "providers", width: "120px" },
      {
        Header: "Odds Limit Reaction",
        accessor: "oddsLimitReaction",
        Cell: makerollover,
        width: "120px",
      },
      {
        Header: "Odd Suspension",
        accessor: "suspension_type",
        Cell: renderSuspension,
        width: "120px",
      },
      {
        Header: "Odd Margin",
        accessor: "margin_type",
        Cell: renderMargin,
        width: "120px",
      },
      { Header: "Min Price", accessor: "lowerlimit", width: "120px" },
      { Header: "Max Price", accessor: "upperlimit", width: "120px" },
      { Header: "Mixing Type", accessor: "mixingType", Cell: makerollover, width: "120px" },
      { Header: "Mixing With Provider", accessor: "mixingProvider", width: "120px" },
      {
        Header: "Price Factor Behaviour",
        accessor: "randomFactor",
        Cell: makerollover,
        width: "120px",
      },
      { Header: "Price Factor", accessor: "factor", width: "120px" },
      { Header: "action", accessor: "action", width: "120px" },
    ],

    rows: [],
  });

  const mixingOptions = [
    { value: 0, label: "No Mixing" },
    { value: 1, label: "Highest Price" },
    { value: 2, label: "Percentage Weight" },
  ];

  const oddsReactions = [
    { value: 0, label: "Do Nothing" },
    { value: 1, label: "Suspend Odds" },
    { value: 2, label: "Set Odds to Limits" },
    { value: 3, label: "Suspend Market" },
  ];

  const suspensionTypes = [
    { value: 0, label: "Never", info: "" },
    { value: 1, label: "One Provider Suspend Odd", info: "" },
    { value: 2, label: "All Providers Suspend Odd", info: "" },
    { value: 3, label: "The Most of the Providers Suspend Odd", info: "" },
    // { value: 4, label: "Ordered Providers Suspend Odd", info: "" },
    { value: 5, label: "According sorted Providers", info: "" },
  ];

  const marginTypes = [
    { value: 0, label: "No Margin", info: "" },
    { value: 1, label: "All odds get same margin (EM)", info: "" },
    { value: 2, label: "Highest odds get more margin (MPTO)", info: "" },
    { value: 3, label: "Lowest odds get more margin (MPTP)", info: "" },
  ];

  
  
  let platforms = userData
    ? userData.platforms
      ? userData.platforms.map((platform) => ({
          value: platform.id,
          label: platform.name,
          logo: platform.logo,
          sorting: platform.sorting,
          odds_styles: platform.odds_styles,
        }))
      : []
    : [];

  function makerollover({ value, ...rest }) {
    let listItems = [
      { key: "min Price", value: rest.row.original.lowerlimit },
      { key: "max Price", value: rest.row.original.upperlimit },
    ];

    if (rest.column.Header === "Odds Limit Reaction") {
      listItems = [
        { key: "min Price", value: rest.row.original.lowerlimit },
        { key: "max Price", value: rest.row.original.upperlimit },
      ];
    }

    if (rest.column.Header === "Mixing Type") {
      if (value == "No Mixing") return <>{value}</>;
      listItems = [
        {
          key: "Mixing with",
          value: rest.row.original.mixingProvider
            ? rest.row.original.mixingProvider.toUpperCase()
            : "",
        },
        {
          key: "Odd price difference (Higher-Lower)",
          value:
            rest.row.original.mixing_odd_limit && rest.row.original.mixing_odd_limit != ""
              ? rest.row.original.mixing_odd_limit + "%"
              : "0%",
        },
      ];
    }

    return rest.column.Header === "Price Factor Behaviour" ? (
      rest.row.original.static_odd_reaction_json &&
      rest.row.original.static_odd_reaction_json.length == 1 &&
      JSON.stringify(rest.row.original.static_odd_reaction_json[0].value) ==
        JSON.stringify(defaultStaticOddReactionJson.value) ? (
        <HtmlTooltip
          placement="right"
          title={
            <React.Fragment>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {listItems.map((item, index) => {
                  return (
                    <div key={index} style={{ width: "180px", display: "inline-flex" }}>
                      {item.key}
                      {item.key ? ": " : ""} {item.value}
                    </div>
                  );
                })}
              </div>
            </React.Fragment>
          }
        >
          <span style={{ paddingLeft: "5px" }}>No Manipulation</span>
        </HtmlTooltip>
      ) : (
        <span style={{ paddingLeft: "5px" }}>Odd Prices will be Manipulated</span>
      )
    ) : (
      <HtmlTooltip
        placement="right"
        title={
          <React.Fragment>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "row",
                maxWidth: rest.column.Header === "Mixing Type" ? "200px" : "",
              }}
            >
              {listItems.map((item, index) => {
                return (
                  <div key={index} style={{ width: "180px", display: "inline-flex" }}>
                    {item.key}
                    {item.key ? ": " : ""} {item.value}
                  </div>
                );
              })}
            </div>
          </React.Fragment>
        }
      >
        <Button className="table-button">
          {value}
          <span style={{ paddingLeft: "5px" }}> </span>
          <Icon>info_outlined</Icon>
        </Button>
      </HtmlTooltip>
    );
  }

  function showEnabled({ value, ...rest }) {
    return (
      <HtmlTooltip
        placement="right"
        title={
          <React.Fragment>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {rest.row.original.template_status ? "Enabled" : "Disabled"}
            </div>
          </React.Fragment>
        }
      >
        <span
          style={{
            paddingLeft: "5px",
            color: rest.row.original.template_status ? "#cb0c9f" : "",
          }}
        >
          {value}
        </span>
      </HtmlTooltip>
    );
  }

  function renderSuspension({ value, ...rest }) {
    return value == 5 ? (
      <HtmlTooltip
        placement="right"
        title={
          <React.Fragment>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              Sorted Providers:{" "}
              {rest.row.original.suspension_provider_id
                ? rest.row.original.suspension_provider_id
                    .split(",")
                    .map((item) => {
                      return providersOptions
                        ? providersOptions.find((mp) => mp.value == item)["label"]
                        : "";
                    })
                    .join(", ")
                : "Sorted Providers: - "}
            </div>
          </React.Fragment>
        }
      >
        <Button className="table-button">
          {suspensionTypes.find((item) => item.value == value)["label"]}
          <span style={{ paddingLeft: "5px" }}> </span>
          <Icon>info_outlined</Icon>
        </Button>
      </HtmlTooltip>
    ) : (
      <span>{suspensionTypes.find((item) => item.value == value)["label"]}</span>
    );
  }

  function renderMargin({ value, ...rest }) {
    return value != 0 && value ? (
      <HtmlTooltip
        placement="right"
        title={
          <React.Fragment>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              Percentage: {rest.row.original.margin_percent}%
            </div>
          </React.Fragment>
        }
      >
        <Button className="table-button">
          {marginTypes.find((item) => item.value == value)["label"]}
          <span style={{ paddingLeft: "5px" }}> </span>
          <Icon>info_outlined</Icon>
        </Button>
      </HtmlTooltip>
    ) : (
      <span>
        {value ? marginTypes.find((item) => item.value == value)["label"] : marginTypes[0]["label"]}
      </span>
    );
  }

  const handleOpenOddsStylesMenu = (event) => {
    event.preventDefault();
    setOpenOddsStylesMenu(event.currentTarget);
  };
  const handleCloseOddsStylesMenu = () => {
    if (changesExist) {
      Swal.fire({
        title: `Unsaved Data!`,
        html: `You have unsaved changes! </br>Are you sure you want to cancel them?`,
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: "Yes",
        denyButtonText: "Cancel",
        icon: "warning",
        confirmButtonColor: "#87cb16",
        denyButtonColor: "#ff4a55",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setOpenOddsStylesMenu(false);
          setOddsStyles(platform.odds_styles);
          setChangesExist(false);
        }
      });
    } else {
      setOpenOddsStylesMenu(false);
    }
  };

  const handleOddsStylesChange = (event, oddsStyle) => {
    event.preventDefault();
    if (oddsStyle.length) {
      setOddsStyles(oddsStyle);
      setChangesExist(true);
    }
  };

  const checkOddsStylesSelected = (oddStyle) => {
    if (oddsStyles && oddsStyles.indexOf(oddStyle) > -1) {
      return true;
    }
    return false;
  };

  const handleOddsStylesSave = async (event) => {
    event.preventDefault();
    if (oddsStyles && oddsStyles.length) {
      // console.log("SAVE", oddsStyles);
      const changedOddsStyles = oddsStyles;

      Swal.fire({
        title: "We proccess your request! ",
        html: "Please Wait a few seconds...",
        timerProgressBar: true,
        didOpen: async () => {
          Swal.showLoading();
          let setTemplatesEndpoint = `/api/v1/platforms/${platform.value}/odds-styles`;
          const oddsStylesToSend = [...oddsStyles];
          oddsStylesToSend.shift();
          let response = await putData(
            setTemplatesEndpoint,
            { odds_styles: oddsStylesToSend.join(",") },
            {
              Authorization: getAuthorizationHeader(),
            }
          );

          if (!response) {
            Swal.clickDeny();
          } else {
            if (response.status === 200) {
              Swal.clickConfirm();
            }
          }
        },
        willClose: () => {},
        allowOutsideClick: false,
      }).then((result) => {
        /* Read more about handling dismissals below */
        // setDeleteModal(false);
        // setRecordToDelete(0);
        if (result.isConfirmed) {
          Swal.fire("Request Sent!", `Live Data sent to the platform`, "success");
          setOddsStyles(oddsStyles);
        }
        if (result.isDenied) {
          // initData();
          Swal.fire(
            "Error!",
            `Live Data didn't send to the platform. Please try again later!`,
            "error"
          );
        }
        setChangesExist(false);
      });

      const updatedPlatforms = platforms.map((p) => {
        if (p.value === platform.value) p.odds_styles = changedOddsStyles;
        return {
          id: p.value,
          name: p.label,
          logo: p.logo,
          sorting: p.sorting,
          odds_styles: p.odds_styles,
        };
      });
      await setUserData({
        key: "platforms",
        value: updatedPlatforms,
      });
      platforms = platforms.map((p) => {
        if (p.value === platform.value) p.odds_styles = changedOddsStyles;
        return {
          value: p.value,
          label: p.label,
          logo: p.logo,
          sorting: p.sorting,
          odds_styles: p.odds_styles,
        };
      });
      setPlatform(dispatch, {
        label: platform.label,
        value: platform.value,
        logo: platform.logo,
        sorting: platform.sorting,
        odds_styles: changedOddsStyles,
      });
      await setUserData({
        key: "defaultPlatform",
        value: {
          label: platform.label,
          value: platform.value,
          logo: platform.logo,
          sorting: platform.sorting,
          odds_styles: changedOddsStyles,
        },
      });
      setChangesExist(false);
      setOpenOddsStylesMenu(false);
    }
  };

  /**
   *
   */
  const handleInformParent = () => {
    initData();
  };

  /**
   *
   */
  const handleCreateRecord = () => {
    setCreateModal(true);
  };

  /**
   *
   * @param {*} e
   * @param {*} id
   */
  const handleOpenModal = (e, id) => {
    e.preventDefault();
    setRecordToDelete(id);
    setDeleteModal(true);
  };

  /**
   *
   * @param {*} update
   * @param {*} id
   */
  const handleDeleteCloseModal = async (update, id) => {
    if (update) {
      let idToSend = id;
      function returnId() {
        return idToSend;
      }
      Swal.fire({
        title: "We proccess your request! ",
        html: "Please Wait a few seconds...",
        timerProgressBar: true,
        didOpen: async () => {
          Swal.showLoading();
          let setTemplatesEndpoint = `/api/v1/oddsfilters/${returnId()}`;
          let response = await delData(setTemplatesEndpoint, {
            Authorization: getAuthorizationHeader(),
          });

          if (!response) {
            Swal.clickDeny();
          } else {
            if (response.status === 200) {
              deleteRecord(returnId());
              initData();

              Swal.clickConfirm();
            }
          }
        },
        willClose: () => {},
        allowOutsideClick: false,
      }).then((result) => {
        /* Read more about handling dismissals below */
        setDeleteModal(false);
        setRecordToDelete(0);
        if (result.isConfirmed) {
          Swal.fire("Request Sent!", `Live Data sent to the platform`, "success");
        }
        if (result.isDenied) {
          initData();
          Swal.fire(
            "Error!",
            `Live Data didn't send to the platform. Please try again later!`,
            "error"
          );
        }
      });
    } else {
      //console.log("Delete canceled, do nothing!");
      setDeleteModal(false);
      setRecordToDelete(0);
    }
  };

  const handleOpenEditModal = (e, oddFilterData) => {
    // setRecordSelectedProvider(provider);
    // setRecordSelectedTemplate(templateId.toString());
    // setRecordSelectedTemplateName(templateName.toString());
    setRecordSelectedData(oddFilterData);
    setRecordToDelete(oddFilterData.id);
    setCreateModal(true);
  };

  /**
   *
   * @param {*} e
   * @param {*} id
   */
  const handleCheckCloneAction = async (e, marketConfig) => {
    e.preventDefault();
    //console.log("id", template.id);
    let marketConfigData = marketConfig;
    let marketConfigToSend = {
      name: marketConfigData.name,
      status: marketConfigData.status === "Enabled" ? false : true,
      platform_id: marketConfigData.platform_id,
    };

    let selectedPlatforms = {};

    for (let index = 0; index < platforms.length; index++) {
      const platform = platforms[index];
      selectedPlatforms[platform.value] = platform.label;
    }

    if (Object.keys(selectedPlatforms).length > 0) {
      const { value: platform } = await Swal.fire({
        icon: "question",
        title: "Select the Platform you want to copy the selected Template",
        input: "select",
        inputOptions: selectedPlatforms,
        inputPlaceholder: "Select Platform",
        showCancelButton: true,
        confirmButtonColor: "#87cb16",
        cancelButtonColor: "#ff4a55",
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value) {
              resolve();
            } else {
              resolve("You need to select a platform or press cancel.");
            }
          });
        },
      });
      if (platform) {
        marketConfig.platform_id = platform * 1;
        handleCloneAction(null, marketConfig);
      }
    } else {
      Swal.fire(
        "Error!",
        `The selected Template you try to copy, can't be applied to any of your available Platforms.`,
        "error"
      );
    }
  };

  const handleCloneAction = async (e, marketConfig) => {
    e.preventDefault();
    //console.log("id", template.id);
    let marketConfigData = marketConfig;
    let marketConfigToSend = {
      name: marketConfigData.name,
      status: marketConfigData.status === "Enabled" ? false : true,
      platform_id: marketConfigData.platform_id,
      odds_filters_id: marketConfigData.odds_filters_id,
    };

    function returnId() {
      return marketConfigData.id;
    }

    function returnTemplateToSend() {
      return marketConfigToSend;
    }

    Swal.fire({
      title: "We proccess your request! ",
      html: "Please Wait a few seconds...",
      timerProgressBar: true,
      didOpen: async () => {
        Swal.showLoading();
        let setTemplatesEndpoint = `/api/v1/oddsFilters/${returnId()}/clone`;

        let response = await postData(setTemplatesEndpoint, returnTemplateToSend(), {
          Authorization: getAuthorizationHeader(),
        });

        if (!response) {
          Swal.clickDeny();
        } else {
          if (response.status === 200) {
            Swal.clickConfirm();
          }
        }
      },
      willClose: () => {},
      allowOutsideClick: false,
    }).then((result) => {
      /* Read more about handling dismissals below */
      initData();
      if (result.isConfirmed) {
        Swal.fire("Request Sent!", `Live Data sent to the platform`, "success");
      }
      if (result.isDenied) {
        Swal.fire(
          "Error!",
          `Live Data didn't send to the platform. Please try again later!`,
          "error"
        );
      }
    });
  };

  /**
   *
   * @param {*} update
   * @param {*} name
   */
  const handleCloseModal = async (update) => {
    setRecordToDelete(0);
    if (update) {
      initData();
    } else {
      //console.log("Creation canceled, do nothing!");
    }
    // setFiltersSelection([]);
    //setRecordSelectedProvider(null);
    //setRecordSelectedTemplate("0");
    //setRecordSelectedTemplateName("0");
    setRecordSelectedData(null);
    setRecordToDelete(0);

    setCreateModal(false);
  };

  /**
   *
   */
  async function initData() {
    if (!platform || platform == "") return;
    if (!providersOptions || providersOptions == "") return;
    setLoading(true);
    let selectedPlatformId = platform.value;
    setOddsStyles(platform.odds_styles);
    let getTemplatesEndpoint = `/api/v1/oddsfilters/platforms/${selectedPlatformId}`;
    let response = await getData(
      getTemplatesEndpoint,
      { Authorization: getAuthorizationHeader() },
      null,
      abortController ? { signal: abortController.signal } : null
    );
    if (response != null) {
      let selections = [];
      response.data.map((el) => {
        el.providers = el.provider_name;
        el.filter = el.id;
        el.template = el.template_name;
        el.id = el.id;
        el.static_odd_reaction = el.static_odd_reaction;
        el.oddsLimitReaction = oddsReactions.find(
          (item) => item.value == el.barrier_reaction_type
        ).label;
        el.lowerlimit = el.min_odd_barrier;
        el.upperlimit = el.max_odd_barrier;
        el.mixingType = mixingOptions.find((item) => item.value == el.mixing_odd_type).label;
        el.mixingProvider = "";
        el.mixingProviders = el.mixing_provider_names;
        for (let index = 0; index < el.mixing_providers.length; index++) {
          const mixingProvider = el.mixing_providers[index];
          mixingProvider.percentage = mixingProvider.percentage * 100;
          el.mixingProvider =
            el.mixingProvider === ""
              ? mixingProvider.provider_name
              : el.mixingProvider + ", " + mixingProvider.provider_name;
        }
        el.factor = el.static_odd_reaction;
        el.randomFactor = el.random_odd_reaction ? "Random Apply" : "Allways Apply";

        el.action = (
          <ActionCell
            handleDeleteAction={(e) => handleOpenModal(e, el.id)}
            handleEditAction={(e) => handleOpenEditModal(e, el)}
            handleCheckCloneAction={(e) => handleCheckCloneAction(e, el)}
          />
        );
        selections.push({
          value: el.template_id + "--" + el.filter + "--" + el.provider_id,
          label: el.name,
        });
      });
      //setFiltersSelection(selections);
    } else {
    }

    let data = { ...dataTableData };
    data.rows = response && response.data ? response.data : data.rows;

    data.rows.sort((a, b) => b.id - a.id);

    //console.log("Init Data");
    setDataTableData(data);
    setLoading(false);
  }

  /**
   *
   * @param {*} id
   */
  function deleteRecord(id) {
    //console.log("deleteRecord:", id);
    let initData = { ...dataTableData };
    let initDataRows = [...dataTableData.rows];

    let indexToRemove = initDataRows.findIndex((template) => template.id === id);
    initDataRows.splice(indexToRemove, 1);

    initData.rows = initDataRows;
    setDataTableData(initData);
  }

  // Render the notifications menu
  const renderUserMenu = () => (
    <Menu
      anchorEl={openOddsStylesMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openOddsStylesMenu)}
      onClose={handleCloseOddsStylesMenu}
      sx={{ mt: 2 }}
    >
      <SoftBox>
        <Grid>
          <ToggleButtonGroup
            orientation="vertical"
            value={oddsStyles}
            onChange={handleOddsStylesChange}
            aria-label="device"
          >
            <ToggleButton
              className={"opacity-revert"}
              value="decimal"
              aria-label="decimal"
              disabled={oddsStyles && oddsStyles.indexOf((odd) => odd == "decimal") == -1}
              sx={{ opacity: "100%" }}
            >
              <SoftTypography
                variant="normal"
                component="div"
                style={{ minWidth: "100%", textAlign: "left", paddingLeft: "10px" }}
              >
                Decimal - European
              </SoftTypography>
              <CheckIcon
                className={"opacity-revert"}
                style={{ opacity: "100% !important" }}
                color={"success"}
              />
            </ToggleButton>
            <ToggleButton value="fractional" aria-label="fractional">
              <SoftTypography
                variant="normal"
                component="div"
                style={{ minWidth: "100%", textAlign: "left", paddingLeft: "10px" }}
              >
                Fractional - British
              </SoftTypography>
              <Icon
                className={checkOddsStylesSelected("fractional") ? "" : "hidden"}
                color={"success"}
              >
                check_outlined_icon
              </Icon>
            </ToggleButton>
            <ToggleButton value="moneyline" aria-label="moneyline">
              <SoftTypography
                variant="normal"
                component="div"
                style={{ minWidth: "100%", textAlign: "left", paddingLeft: "10px" }}
              >
                Moneyline - American
              </SoftTypography>
              <Icon
                className={checkOddsStylesSelected("moneyline") ? "" : "hidden"}
                color={"success"}
              >
                check_outlined_icon
              </Icon>
            </ToggleButton>
            <ToggleButton value="hongKong" aria-label="hongKong">
              <SoftTypography
                variant="normal"
                component="div"
                style={{ minWidth: "100%", textAlign: "left", paddingLeft: "10px" }}
              >
                Hong Kong
              </SoftTypography>
              <Icon
                className={checkOddsStylesSelected("hongKong") ? "" : "hidden"}
                color={"success"}
              >
                check_outlined_icon
              </Icon>
            </ToggleButton>
            <ToggleButton value="malay" aria-label="malay">
              <SoftTypography
                variant="normal"
                component="div"
                style={{ minWidth: "100%", textAlign: "left", paddingLeft: "10px" }}
              >
                Malay
              </SoftTypography>
              <Icon className={checkOddsStylesSelected("malay") ? "" : "hidden"} color={"success"}>
                check_outlined_icon
              </Icon>
            </ToggleButton>
            <ToggleButton value="indonesian" aria-label="indonesian">
              <SoftTypography
                variant="normal"
                component="div"
                style={{ minWidth: "100%", textAlign: "left", paddingLeft: "10px" }}
              >
                Indonesian
              </SoftTypography>
              <Icon
                className={checkOddsStylesSelected("indonesian") ? "" : "hidden"}
                color={"success"}
              >
                check_outlined_icon
              </Icon>
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
        <Grid style={{ textAlign: "right" }}>
          <SoftButton color="dark" onClick={handleOddsStylesSave} disabled={!changesExist}>
            Save
          </SoftButton>
        </Grid>
      </SoftBox>
    </Menu>
  );

  useEffect(() => {
    if (providers) {
      providersOptions = providers;
      initData();
    }
  }, [platform.label, providers]);

  useEffect(() => {
    return () => {
      if (abortController) {
        // console.log("abortController");
        abortController.abort();
      }
    };
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <CreateOddsFilter
        id={recordToDelete}
        data={recordSelectedData}
        showModal={showCreateModal}
        signalCloseModal={handleCloseModal}
      ></CreateOddsFilter>
      <CheckObjectDeletion
        referenceId={recordToDelete}
        reference={"odd"}
        showModal={showDeleteModal}
        signalCloseModal={handleDeleteCloseModal}
      ></CheckObjectDeletion>
      <SoftBox my={3}>
        <Card>
          <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
            <SoftBox lineHeight={1}>
              <SoftTypography variant="h5" fontWeight="medium">
                Your Odds&apos; Settings
              </SoftTypography>
              <SoftTypography variant="button" fontWeight="regular" color="text">
                Here you can find all the saved Odd Settings you have setup
              </SoftTypography>
            </SoftBox>
            <Stack spacing={1} direction="row">
              <SoftButton
                variant="gradient"
                color="warning"
                size="small"
                onClick={handleOpenOddsStylesMenu}
              >
                Odds Format
              </SoftButton>
              <SoftButton variant="gradient" color="info" size="small" onClick={handleCreateRecord}>
                + new Odd Filter
              </SoftButton>
            </Stack>
            {renderUserMenu()}
          </SoftBox>
          <DataTable
            table={dataTableData}
            entriesPerPage={{
              defaultValue: 10,
              entries: [5, 10, 15, 20, 25],
            }}
            hiddenColumns={["lowerlimit", "upperlimit", "mixingProvider", "factor"]}
            refreshEnabled={true}
            openBackDrop={loading}
            informParent={handleInformParent}
            canSearch
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default OddsSettingsList;
